/**
 * Created by zato93 on 10/27/17.
 */
import Vue from 'vue';
import Vuex from "vuex";
Vue.use(Vuex);
import profile from "../../components/desktop/i-profile.store.js";
import modals from "../../components/desktop/modals.store.js";
import payments from "../../components/desktop/modules/payments.store.js";
//import auth from "../../components/desktop/auth.store.js";

export default new Vuex.Store({
    modules: { profile, modals, payments},
    state:{
        lang:'en',
        loaded:false,
        server:{
            host: location.hostname,
            port:"3001",
            path:"api/v1",
            item: "value",
            method: 'post'
        },
        cams:[],
        cities:[]
    }
});